// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qc-card{width:90%;padding:30px;background-color:#fff}", ""]);
// Exports
module.exports = exports;
